import React, { createContext, useContext, useState, useCallback } from 'react';

// steps: 'login' | 'register' | 'verify-otp' | 'forgot-password' | 'reset-password'
const AuthModalContext = createContext(null);

export const AuthModalProvider = ({ children }) => {
  const [isOpen, setIsOpen]   = useState(false);
  const [step, setStep]       = useState('login');
  const [modalEmail, setModalEmail]           = useState('');
  const [modalPhone, setModalPhone]           = useState('');
  const [modalResetToken, setModalResetToken] = useState('');
  const [otpPurpose, setOtpPurpose]           = useState('email-verify');

  const openLoginModal = useCallback((s = 'login') => {
    setStep(s);
    setIsOpen(true);
  }, []);

  const closeLoginModal = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => { setStep('login'); setModalEmail(''); setModalPhone(''); setModalResetToken(''); }, 300);
  }, []);

  const goTo = useCallback((s, opts = {}) => {
    if (opts.email)      setModalEmail(opts.email);
    if (opts.phone)      setModalPhone(opts.phone);
    if (opts.resetToken) setModalResetToken(opts.resetToken);
    if (opts.purpose)    setOtpPurpose(opts.purpose);
    setStep(s);
  }, []);

  return (
    <AuthModalContext.Provider value={{
      isOpen, step, modalEmail, modalPhone, modalResetToken, otpPurpose,
      openLoginModal, closeLoginModal, goTo,
    }}>
      {children}
    </AuthModalContext.Provider>
  );
};

export const useAuthModal = () => {
  const ctx = useContext(AuthModalContext);
  if (!ctx) throw new Error('useAuthModal must be used within AuthModalProvider');
  return ctx;
};
